const MedicineDictionaryInnerSectionDivider = () => {
  return <div className='h-[1px] w-full bg-gray-40' />;
};

export default MedicineDictionaryInnerSectionDivider;
